// /\w\S*/g will match any word character and not whitespace characters.
export const toTitleCase = (text: string) =>
  text.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
